import { React, useState, useRef, useEffect } from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTable from "examples/Tables/DataTable";
import IconButton from "@mui/material/IconButton";
import AssignmentIcon from "@mui/icons-material/Assignment";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import Button from "@mui/material/Button";
import { ToastContainer, toast } from "react-toastify";
import { Dropdown } from "semantic-ui-react";
import Tooltip from "@mui/material/Tooltip";
import { Stack } from "@mui/material";
import InputBase from "@mui/material/InputBase";
import Paper from "@mui/material/Paper";
import SearchIcon from "@mui/icons-material/Search";
import Papa from "papaparse";
import MDBadge from "components/MDBadge";
import MDTypography from "components/MDTypography";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import DescriptionIcon from "@mui/icons-material/Description";
import VisibilityIcon from "@mui/icons-material/Visibility";
import colors from "assets/theme/base/colors";
import "../campus/Campus.css";
import Select from "react-select";

const { info } = colors;
const BASE_URL = process.env.REACT_APP_BASE_URL;
const token = sessionStorage.getItem("token");

function ManageApplications() {
  // Variable Declarations
  const [applications, setApplications] = useState([]);
  const [all_campaigns, setAllCampaigns] = useState([]);
  const [campaign_id, setCampaignId] = useState("");
  const [filter, setFilter] = useState("");
  const [searchKeyword, setSearchKeyword] = useState("");
  const [genderFilter, setGenderFilter] = useState("");
  const [nationalityFilter, setNationalityFilter] = useState("");
  const nationalities = ["Pakistani", "Overseas"];
  const genders = ["Male", "Female", "Other"];
  const [originalApplications, setOriginalApplications] = useState([]); // Store original applications

  //Dialog Settings
  const [open, setOpen] = useState(false);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  const [anchorEl, setAnchorEl] = useState(null);
  const [opens, setOpens] = useState(false);
  const [currentAppId, setCurrentAppId] = useState(null);

  const handleClick = (event, appId) => {
    setAnchorEl(event.currentTarget);
    setOpens(true);
    setCurrentAppId(appId);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setOpens(false);
    setCurrentAppId(null);
  };

  const handleViewApplication = (id) => {
    window.open(`/get-applications/${id}`);
  };
  const handleViewApplicationTwo = (id) => {
    window.open(`/view-application-two/${currentAppId}`);
  };

  // Session Storage handling
  var user = JSON.parse(sessionStorage.getItem("user"));
  if (user) {
    var organization_id = user.organization_id;
  } else {
    var organization_id = null;
  }

  // Rows & Columns Injection
  const columns = [
    { Header: "Sr.No", accessor: "serial", align: "center" },
    { Header: "Application ID", accessor: "applicant_id", align: "left" },
    { Header: "Applicant Name", accessor: "name", align: "center" },
    { Header: "Father Name", accessor: "father_name", align: "center" },
    { Header: "Gender", accessor: "gender", align: "center" },
    { Header: "DOB", accessor: "dob", align: "center" },
    { Header: "Province", accessor: "province", align: "center" },
    { Header: "Current Address", accessor: "current_address", align: "center" },
    { Header: "Status", accessor: "status", align: "center" },
    { Header: "Actions", accessor: "actions", align: "center" },
  ];

  const rows =
    applications.length > 0
      ? applications.map((app, index) => ({
        serial: index + 1,
        applicant_id: app.id,
        name: app.name,
        father_name: app.father_name,
        gender: app.gender,
        dob: app.dob,
        province: app.p_province,
        current_address: app.current_address,
        status:
          app.is_completed === 0 && app.is_verified === 0 ? (
            <MDBox ml={-1}>
              <MDBadge
                badgeContent="Incomplete"
                color="warning"
                variant="gradient"
                size="sm"
              />
            </MDBox>
          ) : app.is_completed === 1 && app.is_verified === 1 ? (
            <MDBox ml={-1}>
              <MDBadge
                badgeContent="Accepted"
                color="success"
                variant="gradient"
                size="sm"
              />
            </MDBox>
          ) : app.is_completed === 0 && app.is_verified === 2 ? (
            <MDBox ml={-1}>
              <MDBadge
                badgeContent="Rejected"
                color="error"
                variant="gradient"
                size="sm"
              />
            </MDBox>
          ) : app.is_completed === 1 && app.is_verified === 0 ? (
            <MDBox ml={-1}>
              <MDBadge
                badgeContent="Completed"
                color="info"
                variant="gradient"
                size="sm"
              />
            </MDBox>
          ) : app.is_completed === 1 && app.is_verified === 2 ? (
            <MDBox ml={-1}>
              <MDBadge
                badgeContent="Resubmitted"
                color="secondary"
                variant="gradient"
                size="sm"
              />
            </MDBox>
          ) : null,
        actions: (
          <>
            <IconButton onClick={() => handleViewApplication(app.id)}>
              <VisibilityIcon style={{ color: "blue" }} />
            </IconButton>
          </>
        ),
      }))
      : [
        {
          serial: null,
          first_name: null,
          last_name: null,
          father_name: null,
          gender: null,
          dob: null,
          city: null,
          country: null,
          status: null,
          actions: null,
        },
      ];

  const handleSearchKeywordChange = (e) => {
    const searchTerm = e.target.value.trim().toLowerCase();
    setSearchKeyword(searchTerm);
    filterApplications(searchTerm, genderFilter, nationalityFilter);
  };

  const handleGenderFilterChange = (e, { value }) => {
    setGenderFilter(value);
    filterApplications(searchKeyword, value, nationalityFilter);
  };

  const handleNationalityFilterChange = (e, { value }) => {
    setNationalityFilter(value);
    filterApplications(searchKeyword, genderFilter, value);
  };

  const filterApplications = (
    searchTerm,
    selectedGender,
    selectedNationality
  ) => {
    let filteredApplications = originalApplications.filter((app) => {
      const idMatch = app.id && app.id.toString().includes(searchTerm);
      const nameMatch = app.name && app.name.toLowerCase().includes(searchTerm);
      const fatherNameMatch =
        app.father_name && app.father_name.toLowerCase().includes(searchTerm);
      const genderMatch =
        selectedGender === "" ||
        selectedGender === "All" ||
        app.gender === selectedGender;
      const nationalityMatch =
        selectedNationality === "" ||
        selectedNationality === "All" ||
        app.nationality === selectedNationality;

      return (
        (idMatch || nameMatch || fatherNameMatch) &&
        genderMatch &&
        nationalityMatch
      );
    });

    setApplications(filteredApplications);
  };

  const handleExportCSV = () => {
    // Define the headers for the CSV
    const headers = [
      "Sr.No",
      "Application ID",
      "User  ID",
      "Campaign ID",
      "Application Type",
      "Title",
      "First Name",
      "Last Name",
      "Applicant Image",
      "Father Name",
      "Gender",
      "DOB",
      "Marital Status",
      "Religion",
      "Permanent House No",
      "Permanent City",
      "Permanent Country",
      "Permanent Province",
      "Current House No",
      "Current City",
      "Current Country",
      "Current Province",
      "Emergency Contact Name",
      "Emergency Contact No",
      "Applicant CNIC",
      "Applicant CNIC Image",
      "Father CNIC",
      "Father CNIC Image",
      "City of Birth",
      "Country of Permanent Residence",
      "Nationality",
      "Disability",
      "Organization ID",
      "Obtained Test Score",
      "Obtained Interview Score",
      "Father Occupation",
      "Father Income",
      "BZU Registration No",
      "Current Address",
      "Permanent Address",
      "Telephone No",
      "Father Phone",
      "Applicant Phone",
      "Place of Stay",
      "Hafiz Quran",
      "Emergency Contact Address",
      "Applicant CNIC Front",
      "Applicant CNIC Back",
      "Father CNIC Front",
      "Father CNIC Back",
      "Need Transport",
      "Campaign Name",
      "Campus Name",
      "Form ID"
    ];

    // Map the rows to include all necessary fields
    const data = applications.map((app, index) => [
      index + 1,
      app.id,
      app.user_id,
      app.campaign_id,
      app.application_type,
      app.title,
      app.first_name,
      app.last_name,
      app.applicant_image,
      app.father_name,
      app.gender,
      app.dob,
      app.marital_status,
      app.religion,
      app.p_house_no,
      app.p_city,
      app.p_country,
      app.p_province,
      app.c_house_no,
      app.c_city,
      app.c_country,
      app.c_province,
      app.emergency_contact_name,
      app.emergency_contact_no,
      app.applicant_cnic,
      app.applicant_cnic_image,
      app.father_cnic,
      app.father_cnic_image,
      app.city_of_birth,
      app.country_of_permanent_residence,
      app.nationality,
      app.disability,
      app.organization_id,
      app.obtained_test_score,
      app.obtained_interview_score,
      app.father_occupation,
      app.father_income,
      app.bzu_registration_no,
      app.current_address,
      app.permanent_address,
      app.tel_no,
      app.father_phone,
      app.applicant_phone,
      app.place_of_stay,
      app.hafiz_quran,
      app.emergency_contact_address,
      app.applicant_cnic_front,
      app.applicant_cnic_back,
      app.father_cnic_front,
      app.father_cnic_back,
      app.need_transport,
      app.campaign_name,
      app.campus_name,
      app.form_id
    ]);

    // Combine headers and data
    const csvData = [headers, ...data];

    // Convert to CSV format
    const csv = Papa.unparse(csvData);

    // Create a blob and download the CSV
    const blob = new Blob([csv], { type: "text/csv" });
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = "Applications.csv";

    link.click();
  };

  const handleCampaignType = (value) => {
    setCampaignId(value);
    setGenderFilter(""); // Reset gender filter
    setNationalityFilter(""); // Reset nationality filter
    getApplications(value); // Fetch applications for the selected campaign
  };

  const handleFilterChange = (value) => {
    console.log("Value received:", value);

    if (value === "all") {
      console.log("Getting all applications");
      getApplications(campaign_id);
    } else {
      console.log("Setting filter and getting applications by filter");
      setFilter(value);
      getApplicationsByFilter(value);
    }
  };

  // const handleSearchKeywordChange = (e) => {
  //   const searchTerm = e.target.value.trim().toLowerCase();
  //   setSearchKeyword(searchTerm);

  //   if (searchTerm === "") {
  //     getApplications(campaign_id);
  //   } else {
  //     let filteredApplications = applications.filter((app) => {
  //       const idMatch = app.id && app.id.toString().includes(searchTerm);
  //       const firstNameMatch =
  //         app.first_name && app.first_name.toLowerCase().includes(searchTerm);
  //       const lastNameMatch =
  //         app.last_name && app.last_name.toLowerCase().includes(searchTerm);
  //       const fatherNameMatch =
  //         app.father_name && app.father_name.toLowerCase().includes(searchTerm);
  //       const genderMatch =
  //         app.gender && app.gender.toLowerCase().includes(searchTerm);
  //       const dobMatch = app.dob && app.dob.toLowerCase().includes(searchTerm);
  //       const cityMatch =
  //         app.c_city && app.c_city.toLowerCase().includes(searchTerm);
  //       const countryMatch =
  //         app.c_country && app.c_country.toLowerCase().includes(searchTerm);

  //       return (
  //         idMatch ||
  //         firstNameMatch ||
  //         lastNameMatch ||
  //         fatherNameMatch ||
  //         genderMatch ||
  //         dobMatch ||
  //         cityMatch ||
  //         countryMatch
  //       );
  //     });

  //     setApplications(filteredApplications);
  //   }
  // };

  // GET Api calls
  const getAllCampaigns = async () => {
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    await fetch(BASE_URL + `/campaign/get_campaigns`, requestOptions)
      .then((response) => response.json())
      .then((data) => {
        setAllCampaigns(data.campaigns);
      })
      .catch((error) => console.log(error));
  };

  const getApplications = async (id) => {
    let data = { campaign_id: id };
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(data),
    };
    await fetch(
      `${BASE_URL}/application/get_all_application_forms_by_campaign`,
      requestOptions
    )
      .then((response) => response.json())
      .then((data) => {
        setApplications(data.applications);
        setOriginalApplications(data.applications);
      })
      .catch((error) => console.log(error));
  };

  const getApplicationsByFilter = async (value) => {
    let data = { campaign_id: campaign_id, filter: value };
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(data),
    };
    await fetch(
      `${BASE_URL}/application/get_filtered_applications_by_campaign`,
      requestOptions
    )
      .then((response) => response.json())
      .then((data) => {
        setApplications(data.applications);
      })
      .catch((error) => console.log(error));
  };

  useEffect(() => {
    getAllCampaigns();
  }, []);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <ToastContainer />
      <MDBox pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Stack direction="row" justifyContent="space-between" alignItems="center">
            <div className="col-md-3">
  <label htmlFor="campaign_id">Campaign</label>
  <Select
    inputId="campaign_id"
    name="campaign_id"
    classNamePrefix="select"
    placeholder="Select Campaign"
    options={all_campaigns.map((camp) => ({
      value: camp.id,
      label: camp.name,
    }))}
    value={
      all_campaigns
        .map((camp) => ({ value: camp.id, label: camp.name }))
        .find((option) => option.value === campaign_id) || null
    }
    onChange={(selected) => handleCampaignType(selected ? selected.value : "")}
  />
</div>
              {campaign_id !== "" && (
                <Grid container spacing={2} justifyContent="flex-end" marginTop={1.5}>
                  <Grid item xs={2}>
                    <Dropdown
                      id="filter"
                      name="filter"
                      placeholder="Status"
                      fluid
                      selection
                      className="form-control"
                      value={filter}
                      onChange={(e, { value }) => handleFilterChange(value)}
                      options={[
                        { key: "0", text: "All", value: "all" },
                        { key: "1", text: "Completed", value: "completed" },
                        { key: "2", text: "Incomplete", value: "incompleted" },
                        { key: "4", text: "Rejected", value: "rejected" },
                      ]}
                    />
                  </Grid>
                  <Grid item xs={2}>
                    <Dropdown
                      id="gender_filter"
                      name="gender_filter"
                      placeholder="Gender"
                      fluid
                      selection
                      className="form-control"
                      value={genderFilter}
                      onChange={handleGenderFilterChange}
                      options={[
                        { key: "all", text: "All", value: "All" },
                        ...genders.map((gender) => ({
                          key: gender,
                          text: gender,
                          value: gender,
                        })),
                      ]}
                    />
                  </Grid>
                  <Grid item xs={2}>
                    <Dropdown
                      id="nationality_filter"
                      name="nationality_filter"
                      placeholder="Nationality"
                      fluid
                      selection
                      className="form-control"
                      value={nationalityFilter}
                      onChange={handleNationalityFilterChange}
                      options={[
                        { key: "all", text: "All", value: "All" },
                        ...nationalities.map((nationality) => ({
                          key: nationality,
                          text: nationality,
                          value: nationality,
                        })),
                      ]}
                    />
                  </Grid>
                </Grid>
              )}
            </Stack>



            <Card className="mt-5 card1">
              <MDBox
                mx={0}
                mt={0}
                py={2}
                px={2}
                variant="gradient"
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                <Stack
                  direction="row"
                  justifyContent="flex-end"
                  alignItems="center"
                  spacing={1}
                  sx={{ width: "100%" }}
                >
                  <Stack sx={{ flexGrow: 1 }}>
                    <Paper component="form" className="search-paper">
                      <InputBase
                        sx={{ ml: 1, flex: 1, fontSize: "16px" }}
                        placeholder="Search"
                        inputProps={{ "aria-label": "search voucher" }}
                        value={searchKeyword}
                        onChange={handleSearchKeywordChange}
                      />
                      <SearchIcon className="search-icon" />
                    </Paper>
                  </Stack>

                  <Button
                    variant="outlined"
                    endIcon={<DescriptionIcon className="add-icon" />}
                    onClick={() => {
                      handleExportCSV();
                    }}
                    className="add-full-button"
                  >
                    Export CSV
                  </Button>
                </Stack>
              </MDBox>
              <MDBox pt={3}>
                {applications && applications.length > 0 ? (
                  <DataTable
                    table={{ columns, rows }}
                    isSorted={false}
                    entriesPerPage={false}
                    showTotalEntries={false}
                    noEndBorder
                  />
                ) : (
                  <div style={{ textAlign: "center" }}>
                    <img
                      src="nodata.png"
                      style={{
                        display: "block",
                        margin: "auto",
                        width: "20%",
                        height: "20%",
                      }}
                    />
                  </div>
                )}
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
    </DashboardLayout>
  );
}

export default ManageApplications;
